import { Component, OnInit } from '@angular/core';
import { APICallingService } from 'src/app/model/APICallingService';
import { IAppSettings ,AppSettings} from '../model/application-settings';
import { Store } from "@ngrx/store";
import * as PageStore from "src/app/Store/PageStore/Page.Actions";
import { Router } from '@angular/router';
@Component({
  selector: 'app-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.css']
})
export class BranchesComponent implements OnInit {

  constructor(private router:Router,private store: Store<any>,private apiCall:APICallingService, private storeAppSettings:AppSettings) { }
   days = ['SUN','MON','TUE','WED','THU','FRI','SAT'];
   res:any=[];
  ngOnInit(): void {
    this.storeSettings= this. storeAppSettings.loadSettings();
  }
  ngAfterViewInit()
  {
    debugger;
    this.getBranchDetails();
   
  }
  storeSettings:IAppSettings=
  {
    faxUserId:'',
    faxPassword:'',

    companyName:'',
      theamColorCode:'#ea0029',
      headerColorCode: '#000',
      headerimage: '../../assets/img/trending1.png',
      loginBackgroundImage:'../../assets/img/logo_web.png',
    loginImage:'../../assets/img/logo_web.png',
      dangerColorCode: '#dc3545',
      successColorCode: '#28a745',
      logo: '../../assets/img/logo_web.png',
      paymentGateway:'',
      key:'',
      selectedBranch:'',
      apiLoginId:'',
      orderEmail:'',
      adminUrl:'',
      orderUrl:'',
      viewName:'AppSettings',
      apiCallingUrl:'',
      fontFamily:'prompt,sans-serif',
      domainName:'',
      fax:'',
      projectId:'',
      
      keyNo:'',
      noOfBranches:0,
      addClover:'',
      cloverAccessToken:'',
      cloverAuthToken:'',
      cloverMerchantId:'',
      cloverEmployeeID:'',
      cloverTenderId:'',
      currency:'',
      transactionkey:'',
  };
  branchClick(selectedBranch:any,index:any)
  {
    debugger;
    debugger;
    let today = new Date();
    var Day = this.days[today.getDay()];
    let res=this.lstBraches[index].lstbranchTimePropL.filter((x: { WeekName: string; }) =>x.WeekName==Day);
    this.res = res;
if((+selectedBranch.IsTodayHoliday)>0)
{ 
  this.router.navigateByUrl('/holidaypage');
} 
// else if(this.res.length == 0){
//       this.router.navigateByUrl('/holidaypage');
// }
else{
  this.store.dispatch(new  PageStore.OpenPage({selectedBranch:selectedBranch,viewName:'selectedBranch'}));
  this.storeSettings.selectedBranch=selectedBranch;
  this.store.dispatch(new  PageStore.OpenPage(this.storeSettings));
  this.router.navigateByUrl('/online-order/home');
}
    // debugger;
    // let today = new Date();
    // var Day = this.days[today.getDay()];
    // let res=this.lstBraches[index].lstbranchTimePropL.filter((x: { WeekName: string; }) =>x.WeekName==Day);
    // if(res.length>0)
    // {
    // const fromTimeString12hr = new Date('1970-01-01T' + res[0].From + 'Z')
    // .toLocaleTimeString('en-US',
    //   {timeZone:'UTC',hour12:true,hour:'numeric',minute:'numeric'}
    // );
    // const toTimeString12hr = new Date('1970-01-01T' +  res[0].To + 'Z')
    // .toLocaleTimeString('en-US',
    //   {timeZone:'UTC',hour12:true,hour:'numeric',minute:'numeric'}
    // );
    // return  fromTimeString12hr+'  to '+toTimeString12hr;
    // }else{
    //   this.router.navigateByUrl('/holidaypage');
    //   return  'Closed';
    // }
  }
  getRestaurantTime(index:any)
  {
    debugger;
    let today = new Date();
    var Day = this.days[today.getDay()];
    let res=this.lstBraches[index].lstbranchTimePropL.filter((x: { WeekName: string; }) =>x.WeekName==Day);
    if(res.length>0)
    {
    const fromTimeString12hr = new Date('1970-01-01T' + res[0].From + 'Z')
    .toLocaleTimeString('en-US',
      {timeZone:'UTC',hour12:true,hour:'numeric',minute:'numeric'}
    );
    const toTimeString12hr = new Date('1970-01-01T' +  res[0].To + 'Z')
    .toLocaleTimeString('en-US',
      {timeZone:'UTC',hour12:true,hour:'numeric',minute:'numeric'}
    );
  return  fromTimeString12hr+'  to '+toTimeString12hr;
  
  }else{
    return  'Closed';
  }
 }

  lstBraches:any=[];
  getBranchDetails()
  {
debugger;

    this.apiCall.DBCalling("getBranches","","","","").subscribe(
      (res:any) => {
        if(res.tasks[0].length>0 )
        {
           debugger;
        
          let lstBraches=res.tasks[0];

          for(let i=0;i<lstBraches.length;i++)
          {

            if(i<(+this.storeSettings.noOfBranches))
            {
              this.lstBraches.push(lstBraches[i])
            }

          }

          for(let i=0;i<this.lstBraches.length;i++)
          {

            if(this.lstBraches[i].lstbranchTimePropL!=null && typeof(this.lstBraches[i].lstbranchTimePropL)!=undefined)
            {
            var resData=((this.lstBraches[i].lstbranchTimePropL).replace(/\n/g, "")).replace(/'/g,"\"");
            
            
            this.lstBraches[i].lstbranchTimePropL=JSON.parse(resData);
            }
            else{
            this.lstBraches[i].lstbranchTimePropL = Object.assign([{}],{BranchID:"0",DeleteFlag: "0",From: "",ID: "",ModifiedBy: "",ModifiedDate: "",Show: "true",To:"",WeekName:""})
          }

            if(this.lstBraches[i].lstDeliveryLocation!=null && typeof(this.lstBraches[i].lstDeliveryLocation)!=undefined)
            {
            var resData=((this.lstBraches[i].lstDeliveryLocation).replace(/\n/g, "")).replace(/'/g,"\"");
            
            
            this.lstBraches[i].lstDeliveryLocation=JSON.parse(resData);
            }
            else{
              this.lstBraches[i].lstDeliveryLocation = Object.assign([{}],{BranchID:"0",DeleteFlag: "0",Charges: "",ID: "",ModifiedBy: "",ModifiedDate: "",Show: "true",LocationID:"",LocationName:"",
              Table:"DeliveryLocation",ZipCode:""})
            } 
           
           // lstDeliveryLocation
            
          }

          this.store.dispatch(new  PageStore.OpenPage( {viewName:'Branch',lstBraches:this.lstBraches}  ));
         
        }
       

       // this.loading = false;
      },
      (err:any) => {

      //  this.loading = false;
      }
    );

  }
}
